import Vue from "vue";
import Vuex from "vuex";
import themes from "@/utils/themes";
import Vuetify from "@/plugins/vuetify";
import i18n from "@/utils/translations";
import { loadBoat } from "@/api/log-entries";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    accessToken: null,
    userBoatId: null,
    theme: themes.defaultTheme,
    locale: "en",
    demo: {
      active: false,
      dialog: { active: false },
    },
    userBoat: null,
  },

  getters: {
    getTheme: (state) => state.theme,
    getAccessToken: (state) => state.accessToken,
    getUserBoatId: (state) => state.userBoatId,
    getLocale: (state) => state.locale,
    getDemoModeStatus: (state) => state.demo.active,
    getDemoModeDialog: (state) => state.demo.dialog,
    getUserBoat: (state) => state.userBoat,
  },

  mutations: {
    setUserBoat(state, payload) {
      state.userBoat = payload;
    },
    setDemoModeStatus(state, payload) {
      state.demo.active = payload;
    },
    setDemoModeDialogStatus(state, payload) {
      state.demo.dialog.active = payload;
    },
    setAccessToken(state, payload) {
      state.accessToken = payload.token;
    },
    setUserBoatId(state, payload) {
      state.userBoatId = payload.userBoatId;
    },
    setLocale(state, payload) {
      state.locale = payload.locale;
      if (typeof payload === "undefined") {
        state.locale = "en";
      }

      Vue.moment.locale(state.locale);
      i18n.locale = state.locale;
    },
    setTheme(state, payload) {
      const setAppTheme = (event = {}) => {
        const theme =
          Object.keys(event).length !== 0 ? event : themes.defaultTheme;

        Vuetify.framework.theme.themes.dark = theme.dark;
        Vuetify.framework.theme.themes.light = theme.light;
        Vuetify.framework.theme.themes.name = theme.name;

        const root = document.documentElement;
        root.style.setProperty("--primary", theme.colorVariables.primary);
        root.style.setProperty("--secondary", theme.colorVariables.secondary);

        state.theme = theme;
      };

      const themeExists = themes.theme.find((element) => {
        return element.hostnames.includes(payload.theme);
      });

      typeof themeExists === "undefined"
        ? setAppTheme()
        : setAppTheme(themeExists);
    },
  },
  actions: {
    fetchUserBoat({ commit, state }) {
      return new Promise((resolve, reject) => {
        loadBoat(state.accessToken, state.userBoatId).then((response) => {
          commit("setUserBoat", response);

          const isDemoBoat = response.shared_access_source;

          if (isDemoBoat == null) {
            commit("setDemoModeStatus", false);
            resolve(response);
            return;
          }

          if (isDemoBoat === "DEMO_BOAT") {
            commit("setDemoModeStatus", true);
            resolve(response);
            return;
          }

          commit("setDemoModeStatus", false);
          resolve(response);
        });
      });
    },
  },
});
